import Config from '../Config';
import axios from 'axios';

export async function updateUserRegistrationActivity(updates) {
    const apiPath = `/public/update-user-registration-activity`;

    const request = {
        url: `https://${Config.DYNAMO_API_URL}${apiPath}`,
        // url: `http://localhost:3001${apiPath}`,
        host: Config.DYNAMO_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        body: JSON.stringify(updates),
        data: updates,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const response = await axios(request);

    return response.data;
}
